import { render, staticRenderFns } from "./exercisesTF.vue?vue&type=template&id=7bccfe7d&scoped=true"
import script from "./exercisesTF.vue?vue&type=script&lang=js"
export * from "./exercisesTF.vue?vue&type=script&lang=js"
import style0 from "./exercisesTF.vue?vue&type=style&index=0&id=7bccfe7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bccfe7d",
  null
  
)

export default component.exports